

function initContactForm() {

    $('.contact-form').validate({
        submitHandler: function() {
             if (typeof (grecaptcha) !== 'undefined') {
                grecaptcha.ready(function () {
                    grecaptcha.execute(RECAPTCHA_KEY, { action: 'submit' }).then(function (token) {
                     $('.contact-form').append('<input class="gr-recaptcha" name="g-recaptcha-response" type="hidden" value="'+token+'"/>');
                        var submitButton = $('.contact-form button[type="submit"]');
                        submitButton.attr('disabled','disabled');
                        
                         var data = $('.contact-form').serialize();
                         var object = {
                            'success': function (response){
                                $('.contact-form .form-response').removeClass('alert-success');
                                $('.contact-form .form-response').removeClass('alert-danger');

                                if(response['status']=='ok'){
                                    $('.contact-form .form-response').addClass('alert-success').show().html(response['message']);
                                     $('form[name="contact-form"]')[0].reset();
                                      submitButton.removeAttr('disabled');
                                     if($('.contact-form').find('.gr-recaptcha').length>0 ){
                                        $('.contact-form').find('.gr-recaptcha').remove();
                                    }
                                    setTimeout(function(){
                                      $('.contact-form .form-response').hide().html('');
                                    }, 3000);
                                }else{
                                     submitButton.removeAttr('disabled');
                                    if($('.contact-form').find('.gr-recaptcha').length>0 ){
                                        $('.contact-form').find('.gr-recaptcha').remove();
                                    }
                                    $('.contact-form .form-response').addClass('alert-danger').show().html(response['message']);
                                }
                            },
                            error: function (data) {
                                submitButton.removeAttr('disabled');
                                if($('.contact-form').find('.gr-recaptcha').length>0 ){
                                    $('.contact-form').find('.gr-recaptcha').remove();
                                }
                                $('.contact-form .form-response').addClass('alert-danger').show().html(data['message']);
                            },
                            'data' : data
                        };
                        $.ajax(object);

                    });
                });
            }


            return false;
        },
        errorPlacement: function(error, element) {
            // error.hide();
        },
        highlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).closest('.form-group').append('<span class=" form-control-feedback"><i class="fa fa-exclamation-triangle"></i></span>');
             $(element).parent().addClass('has-error has-feedback');
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element).parent().find('.form-control-feedback').remove();
             $(element).parent().removeClass('has-error has-feedback');
        }
    });
}
